import { AdminSettingsForm } from 'components/shared/AdminSettings/AdminSettingsForm';
import { Skeleton } from '@mui/material';
import {
  FormFieldsWrapper,
  MAX_WIDTH
} from 'components/shared/AdminSettings/FormFieldsWrapper';
import type { AdminSettingsFormProps } from 'components/shared/AdminSettings/AdminSettingsForm';

interface Props {
  isFetching: boolean;
  fullWidth?: boolean;
}

export const AdminSettingsFormWrapper = (
  props: AdminSettingsFormProps & Props
) => {
  const { isFetching = false, children, fullWidth = false } = props;

  if (isFetching) {
    return (
      <FormFieldsWrapper fullWidth={fullWidth}>
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton
            key={index}
            width={fullWidth ? '100%' : MAX_WIDTH}
            height={40}
          />
        ))}
      </FormFieldsWrapper>
    );
  }

  return (
    <AdminSettingsForm {...props} fullWidth={fullWidth}>
      {children}
    </AdminSettingsForm>
  );
};
